__turbopack_context__.v({
  "active": "ActionMenu-module__PUv4fq__active",
  "footer": "ActionMenu-module__PUv4fq__footer",
  "menu": "ActionMenu-module__PUv4fq__menu",
  "menuContainer": "ActionMenu-module__PUv4fq__menuContainer",
  "menuDivider": "ActionMenu-module__PUv4fq__menuDivider",
  "menuEmpty": "ActionMenu-module__PUv4fq__menuEmpty",
  "menuItem": "ActionMenu-module__PUv4fq__menuItem",
  "menuItemActive": "ActionMenu-module__PUv4fq__menuItemActive",
  "menuItemCheck": "ActionMenu-module__PUv4fq__menuItemCheck",
  "menuItemDanger": "ActionMenu-module__PUv4fq__menuItemDanger",
  "menuItemIcon": "ActionMenu-module__PUv4fq__menuItemIcon",
  "menuItemLabel": "ActionMenu-module__PUv4fq__menuItemLabel",
  "menuScrollable": "ActionMenu-module__PUv4fq__menuScrollable",
  "menuTitle": "ActionMenu-module__PUv4fq__menuTitle",
  "panel": "ActionMenu-module__PUv4fq__panel",
  "popIn": "ActionMenu-module__PUv4fq__popIn",
  "search": "ActionMenu-module__PUv4fq__search",
  "searchAction": "ActionMenu-module__PUv4fq__searchAction",
  "searchInput": "ActionMenu-module__PUv4fq__searchInput",
  "trigger": "ActionMenu-module__PUv4fq__trigger",
});
